/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Popper from "@mui/material/Popper";
import Grow from "@mui/material/Grow";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";

function BaseNavbarMenu({ open, close, openHandler, placement = "bottom-start", children, style = {} }) {

  return (
    <Popper
      anchorEl={open}
      popperRef={null}
      open={Boolean(open)}
      placement={placement}
      transition
      style={{ zIndex: 1000, ...style }}
    >
      {({ TransitionProps }) => (
        <Grow {...TransitionProps} sx={{ transformOrigin: "left top" }}>
          <SoftBox
            bgColor="white"
            shadow="lg"
            borderRadius="xl"
            p={2}
            sx={{
              "&::before": {
                content: '""',
                position: "absolute",
                top: "-15px", // Adjust this to match the gap size
                left: 0,
                width: "100%",
                height: "15px",
              }
            }}
            onMouseEnter={() => openHandler(open)}
            onMouseLeave={close}
          >
            {children}
          </SoftBox>
        </Grow>
      )}
    </Popper>
  );
}


// Typechecking props for the BaseNavbarMenu
BaseNavbarMenu.propTypes = {
  open: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired,
  close: PropTypes.oneOfType([PropTypes.func, PropTypes.bool, PropTypes.object]).isRequired,
  openHandler: PropTypes.oneOfType([PropTypes.func, PropTypes.bool, PropTypes.object]).isRequired,
  placement: PropTypes.string,
  children: PropTypes.node.isRequired,
  style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
};

export default BaseNavbarMenu;
